<template>
    <div>

        <div v-if="editAtividadeComplementar && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        
        <el-form @submit.native.prevent="onSubmitAtividadeComplementar" :model="dados" ref="dados" label-position="top">
            <div v-if="!editAtividadeComplementar || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Situação" prop="situacao" :rules="[$requiredChange]" key="situacao">
                            <el-select v-model="dados.situacao" clearable>
                                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                                <el-option :key="false" label="INATIVO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="3" :md="3">
                        <el-form-item label="Código da Atividade" prop="cod_atividade" :rules="[$requiredBlur]" key="cod_atividade">
                            <el-input v-model="dados.cod_atividade" maxlength="191" v-mask="'####'" v-on:blur="formatData('cod_atividade')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="17" :md="17">
                        <el-form-item label="Nome da Atividade" prop="nome_atividade" :rules="[$requiredBlur]" key="nome_atividade">
                            <el-input v-model="dados.nome_atividade" maxlength="191" v-on:blur="formatData('nome_atividade')" clearable></el-input>
                        </el-form-item>
                    </el-col>                    
                </el-row>  
                     
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Código Área" prop="cod_area" :rules="[$requiredBlur]" key="cod_area">
                            <el-input v-model="dados.cod_area" maxlength="191" v-mask="'####'" v-on:blur="formatData('cod_area')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="20" :md="20">
                        <el-form-item label="Nome Área" prop="nome_area" :rules="[$requiredBlur]" key="nome_area">
                            <el-input v-model="dados.nome_area" maxlength="191" v-on:blur="formatData('nome_area')" clearable></el-input>
                        </el-form-item>
                    </el-col>                    
                </el-row>      

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Código SubÁrea" prop="cod_sub_area" :rules="[$requiredBlur]" key="cod_sub_area">
                            <el-input v-model="dados.cod_sub_area" maxlength="191" v-mask="'####'" v-on:blur="formatData('cod_sub_area')" clearable></el-input>
                        </el-form-item>
                    </el-col> 
                    <el-col :xs="24" :sm="20" :md="20">
                        <el-form-item label="Nome SubÁrea" prop="nome_sub_area" :rules="[$requiredBlur]" key="nome_sub_area">
                            <el-input v-model="dados.nome_sub_area" maxlength="191" v-on:blur="formatData('nome_sub_area')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>      

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-atividade-complementar" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['paramId'],
    data: () => ({
        editAtividadeComplementar: false,
        alert: false,
        dados: {
            id: '',
            situacao: '',
            nome: ''
        }

    }),
    mounted () {

    },
    methods:{
        getAtividadeComplementarById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/atividade-complementar/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
 
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitAtividadeComplementar(){

            document.getElementById("btn-atividade-complementar").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
 
                window.eventBus.$emit('loading', true);                

                if(this.editAtividadeComplementar){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/atividade-complementar/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        
                        this.$emit('onSubmitAtividadeComplementar');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/atividade-complementar/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                    
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$emit('onSubmitAtividadeComplementar');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        resetFormAtividadeComplementar(){
          
            this.dados = { id: '', nome: '', descricao: '', ativa: '', emDestaque: null, imagem: '' };
            this.$refs.dados.clearValidate();
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';            

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getAtividadeComplementarById(value);
                    this.editAtividadeComplementar = true;
                } 
            }
        },
    }
}
</script>
